module.exports = __webpack_public_path__ + "img/YH.9fe8c4f0.png";